<template>
    <div>
        <a class="btn w-inline-block pointer" @click="toggleImportModal">
            <i class="fas fa-upload mr"></i>
            {{trans('messages.import_button_title')}}
        </a>
        <div class="modal fade" @keydown.esc.prevent="closeModal" id="courseImportModal" tabindex="-1" role="dialog"
             aria-labelledby="courseImportModalLabel" aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="courseEventsDatesModalLabel">{{trans('course.importModal.title')}}</h5>
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="showUploader" class="row">
                            <div class="col-sm-12">
                                <uploader
                                    accept=".mar"
                                    @fileUploaded="postUpload"
                                    @chunkUploaded="partiallyUploaded"
                                    :end-point="uploadPackageRoute"
                                    :multiple="true"
                                    :multipart="true"
                                    :multipartChunkSize="10485760"
                                >
                                    <a type="button" slot="browse-btn" class="btn">{{trans('course.importModal.browse')}}</a>
                                    <span slot="clear-btn">{{trans('course.importModal.clear')}}</span>
                                    <span slot="upload-btn">{{trans('course.importModal.start')}}</span>
                                    <span slot="remove-btn">{{trans('course.importModal.remove')}}</span>
                                </uploader>
                                <ul class="p-0">
                                    <li v-for="(fileObj, i) in this.files" class="vuejs-uploader__file" :key="i">
                                        <div class="vuejs-uploader__file--preview">
                                            <span class="vuejs-uploader__file-icon" :class="fileObj.extension">{{ fileObj.extension }}</span>
                                        </div>
                                        <div class="vuejs-uploader__file--meta">
                                            <p class="vuejs-uploader__file--filename">{{ fileObj.file.name }}</p>
                                            <p class="vuejs-uploader__file--filesize">{{ fileObj.formattedFilesize }}</p>

                                            <p v-if="fileObj.error && showErrors">{{ handleError(fileObj.error) }}</p>

                                            <slot name="extra" :fileObj="fileObj"></slot>

                                            <div class="vuejs-uploader__progress">
                                                <div class="vuejs-uploader__progress-bar" :style="progressBarStyle(fileObj)"></div>
                                            </div>

                                        </div>
                                        <div style="min-width: 75px; width: 75px" class="d-flex justify-content-center align-items-center">
                                            <div class="loading" v-if="importing.includes(fileObj)"></div>
                                            <i class="fas fa-check fa-lg" style="color: lightseagreen;" v-if="imported.includes(fileObj)"></i>
                                            <i class="fas fa-exclamation-triangle fa-lg" style="color: darkred;" v-if="failed.includes(fileObj)"></i>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeModal">{{trans('messages.Close')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Uploader from 'vuejs-uploader';

export default {
    name: "CourseImporter",
    components: {
        Uploader,
    },
    props: {
        uploadPackageRoute: {
            type: String,
            required: true,
        },
        removePackageRoute: {
            type: String,
            required: true,
        },
        startPackageImportRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showImportModal: false,
            showUploader: false,
            files: [],
            partials: [],
            importing: [],
            imported: [],
            failed: [],
            canceled: false,
        }
    },
    watch: {
        showImportModal: function (value) {
            let self = this;
            if (value) {
                self.showUploader = true;
                $('#courseImportModal').modal('show');
            } else {
                $('#courseImportModal').modal('hide');
                this.canceled = true;
                let waitCycles = 0;
                var timer = setInterval(function() {
                    if((self.partials.length === 0 && self.importing.length === 0) || waitCycles > 120) {
                        clearInterval(timer);
                        self.files.forEach(function (fileObj) {
                            self.removeFile(fileObj.file.name);
                        })
                        self.files = [];
                        self.canceled = false;
                        self.showUploader = false;
                        if (self.imported.length) {
                            location.reload();
                        }
                    }
                    waitCycles ++;
                }, 500);
            }
        }
    },
    methods: {
        toggleImportModal() {
            this.showImportModal = !this.showImportModal;
        },
        closeModal: function () {
            this.$emit('update-course-event', {save: false});
            this.showImportModal = false;
        },
        importCourse(fileObj) {
            let $end = this.startPackageImportRoute;
            let self = this;
            axios.post($end, { filename: fileObj.file.name }).then(function (response) {
                response = response.data;
                if (response.result === "success") {
                    self.imported.push(fileObj)
                } else {
                    self.failed.push(fileObj)
                }
                let importingCourseIndex = self.importing.findIndex(file => file.name === fileObj.file.name);
                self.importing.splice(importingCourseIndex, 1);
            }).catch(err => {
                this.$data.loader = false;
            });
        },
        postUpload(uploadedResult) {
            let partialIndex = this.partials.findIndex(file => file.name === uploadedResult.file.file.name);
            if (partialIndex !== -1) {
                this.partials.splice(partialIndex, 1);
            }
            this.files.push(uploadedResult.file);
            if (!this.canceled) {
                this.importing.push(uploadedResult.file);
                this.importCourse(uploadedResult.file);
            }
        },
        removeFile(filename) {
            let $end = this.removePackageRoute;
            let self = this;
            axios.post($end, { filename: filename }).then(function (response) {
                response = response.data;
                if (response.result !== 'success') {
                    console.log(response.message);
                }
            }).catch(err => {
                this.$data.loader = false;
            });
        },
        progressBarStyle (fileObj) {
            return this.isMultipartUpload && fileObj.filesize > this.multipartChunkSize
                ? { width: fileObj.multipartUploadPercent + '%' }
                : { width: fileObj.singlepartUploadPercent + '%' };
        },
        partiallyUploaded(filePartial) {
            if (!this.partials.filter(file => file.name === filePartial.file.name).length) {
                this.partials.push(filePartial.file);
            }
        }
    }
}
</script>

<style type="scss">

</style>
